import { FC } from 'react'

import { CategoriesList } from '@/screensComponents/CategoriesList/СategoriesList'

import { CatalogItem } from '@/entities/catalog/types'

import cl from './CatalogMain.module.scss'

export type CatalogMainProps = {
	catalogItems: CatalogItem[]
}

export const CatalogMain: FC<CatalogMainProps> = props => {
	return (
		<section className={cl.root}>
			<h1>Каталог</h1>
			<CategoriesList {...props} />
		</section>
	)
}
